<template>
    <div class="container mb-8 mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">
            <span class="hidden md:inline">{{ sessionStore.user.role === 'user' ? __('Rendeld meg, mi félretesszük Neked a boltunkban') : __('Rendelés') }}</span>
            <span class="md:hidden">{{ __('Rendelés') }}</span>
        </h1>

        <div v-if="sessionStore.user.role !== 'admin'">
            <h3 class="cursor-pointer flex font-semibold items-center justify-center mb-8 text-center uppercase"
                v-bind:class="{ 'text-highlight' : !openInstructions }"
                v-on:click="openInstructions = !openInstructions"
            >
                {{ __('Fontos tudnivalók') }}
                <c-icon class="h-6 ml-2 stroke-slate-800 w-6" icon="chevron-up" v-if="openInstructions" />
                <c-icon class="h-6 ml-2 stroke-highlight w-6" icon="chevron-down" v-else />
            </h3>

            <div class="duration-1000 max-h-[2499px] overflow-hidden transition-all"
                 v-bind:class="{ '!max-h-0' : !openInstructions}"
            >
                <div class="gap-8 grid md:grid-cols-3 mb-8"
                     v-if="sessionStore.user.role === 'user'"
                >
                    <div class="bg-white flex flex-col p-8 text-center">
                        <img class="h-24 mb-8" src="/img/icon-calendar.svg" />
                        <h4 class="font-semibold mb-4 text-highlight text-lg uppercase">{{ __('Rendelés leadása') }}</h4>
                        <p class="text-sm" v-html="__('1. Válaszd ki az átvétel napját.<br />2. A termékek melletti `+` jelekre kattintva állítsd be a megrendelni kívánt mennyiségeket.<br />3. 3. Fogadd el az adatvédelmi tájékoztatót az oldal alján. Amíg nincs elfogadva az adatvédelmi tájékoztató, addig a  zöld `Mentés ` gombbal az oldal aljára tudsz navigálni.<br />4. Nyomj rá a `Rendelés mentése` vagy a `Mentés` gombra.<br />5. Rövid időn belül kapsz egy visszaigazoló e-mailt új megrendelésedről / korábbi rendelésed módosításáról. Az e-mail tartalmazni fogja az összes jövőbeni rendelésed.<br />6. Ellenőrizd le, hogy rendben vannak-e az adatok.<br />Mikor válik véglegessé a rendelésed?<br />Rendelés leadása, módosítása vagy törlése az átvétel előtt két nappal 9:00-ig lehetséges. Például: szerdai átvétel esetén a rendelés hétfőn 9:00-ig, vagy hétfői átvétel esetén szombat 9:00-ig lehetséges, ezután a rendelés véglegessé válik és fizetési kötelezettséggel jár (előtte viszont akármennyiszer módosítható vagy törölhető). A 45/2014. (II. 26.) Kormányrendelet a fogyasztó és a vállalkozás közötti szerződések részletes szabályairól – 29. § (1) bekezdés c) pontja alapján, a fogyasztó kifejezett kérésére készült termék esetén a vásárlástól való elállás joga a fogyasztót nem illeti meg. A megrendelt termékeket Neked készítjük, ezért kérjük, csak akkor adj le rendelést ha valóban el is fogsz érte jönni!<br />Nagyobb rendelési mennyiség esetén írj e-mailt nekünk a rendeles@pipacspekseg.hu címre')"></p>
                    </div>

                    <div class="bg-white flex flex-col p-8 text-center">
                        <img class="h-24 mb-8" src="/img/icon-edit-order.svg" />
                        <h4 class="font-semibold mb-4 text-highlight text-lg uppercase">{{ __('Rendelés módosítása') }}</h4>
                        <p class="text-sm">
                            {{ __('A.) Egy adott napra csak egy rendelést tudsz leadni, tehát amíg nem érkezett el a leadási határidő addig ugyanazt a rendelést tudod módosítani. A mentés gombra minden módosítást követően nyomj rá! A módosításról e-mail értesítőt fogsz kapni.') }}
                        </p>
                        <p class="text-sm">
                            {{ __('B.) Azon partnereinknek, akiknek  online fizetés van beállítva, a sikeres tranzakció megtörténte után a rendelés már nem módosítható, illetve nem lemondható.') }}
                        </p>
                    </div>

                    <div class="bg-white flex flex-col p-8 text-center">
                        <img class="h-24 mb-8" src="/img/icon-instore-pickup.svg" />
                        <h4 class="font-semibold mb-4 text-highlight text-lg uppercase">{{ __('Rendelés átvétele') }}</h4>
                        <p class="text-sm">
                            {{ __('Rendelésed hétköznapokon a sütésrendünknek megfelelően, legkésőbb 17:30-ig tudod átvenni a Reményi Ede utcai üzletünkben. Ha boltunk nyitvatartási idejében, de ettől eltérő időpontban tudnád csak átvenni, akkor kérünk jelezd a rendeles@pipacspekseg.hu címen vagy telefonon a +36704298964 telefonszámon! Fizetni átvételkor tudsz készpénzzel vagy bankkártyával (Az átvételi idősáv változtatásának jogát fenntartjuk).') }}
                        </p>
                    </div>
                </div>

                <div class="bg-white mb-8 md:flex md:items-center md:text-left p-8 text-center"
                     v-if="sessionStore.user.role === 'reseller'"
                >
                    <img class="h-24 mb-8 md:mb-0 md:mr-8 md:h-18 md:ml-0 mx-auto" src="/img/icon-calendar.svg" />
                    <div>
                        <h4 class="font-semibold mb-4 text-highlight text-lg uppercase">{{ __('Rendelés leadása') }}</h4>
                        <p class="text-sm">
                            {{ __('Adott napra a rendelés leadásának határideje az átvétel előtti második nap reggel 9:00 óra. (pl. szerdai átvétel határideje hétfő 9:00)') }}
                        </p>
                    </div>
                </div>

                <div class="bg-white mb-8 md:flex md:items-center md:text-left p-8 text-center"
                     v-if="sessionStore.user.role === 'reseller'"
                >
                    <img class="h-24 mb-8 md:mb-0 md:mr-8 md:h-18 md:ml-0 mx-auto" src="/img/icon-edit-order.svg" />
                    <div>
                        <h4 class="font-semibold mb-4 text-highlight text-lg uppercase">{{ __('Rendelés módosítása') }}</h4>
                        <p class="text-sm">
                            {{ __('A megrendelés a határidő előtt bármikor változtatható (mennyiségi, kenyértípusbeli változtatás vagy lemondás esetén is). A rendelési határidő elérkeztével a rendelés véglegessé válik, ami fizetési kötelezettséggel jár. Fizetés módja előre egyeztetett módon.') }}
                        </p>
                    </div>
                </div>

                <div class="bg-white mb-8 md:flex md:items-center md:text-left p-8 text-center"
                     v-if="sessionStore.user.role === 'reseller'"
                >
                    <img class="h-24 mb-8 md:mb-0 md:mr-2 md:h-18 md:ml-0 mx-auto" src="/img/icon-order-pickup.svg" />
                    <div>
                        <h4 class="font-semibold mb-4 text-highlight text-lg uppercase">{{ __('Kiszállítás') }}</h4>
                        <p class="mb-2 text-sm">
                            {{ __('Bruttó 40.000 HUF alatti rendelési érték esetén csak bolti átvételre van lehetőség.') }}
                        </p>
                        <p class="mb-2 text-sm">
                            {{ __('Bruttó 40.000-80.000 HUF értékű rendelés esetén a megegyezés szerinti kiszállítási díjat számoljuk.') }}
                        </p>
                        <p class="mb-2 text-sm">
                            {{ __('Bruttó 80.000 HUF feletti rendelési érték esetén a kiszállítás díjtalan.') }}
                        </p>
                        <p class="text-sm">
                            {{ __('A kiszállítási időablak meghatározása előzetes egyeztetés alapján történik. Az időpont tájékoztató jellegű, a változtatás jogát fenntartjuk.') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-white px-2 w-full" v-if="products">
        <div class="bg-highlight flex items-center justify-between px-2 py-4 sticky text-white top-[var(--banner-offset)] z-30">
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-if="currentYear >= DateTime.now().setLocale('en').year && currentWeek >= DateTime.now().setLocale('en').weekNumber && currentDay > DateTime.now().setLocale('en').ordinal"
               v-on:click="prevWeek"
            >
                <c-icon class="h-6 mr-2 stroke-white w-6" icon="chevron-left" />
                <span class="hidden md:inline">{{ __('Előző') }}</span>
            </a>
            <span class="md:w-[90px] w-[32px]" v-else>&nbsp;</span>
            <span class="font-serif hidden text-3xl xl:inline">
                {{ __(':week. hét', { week: currentWeek }) }} <small class="font-sans text-base">({{ currentYear }})</small>
            </span>
            <span class="font-serif text-3xl xl:hidden">
                {{ DateTime.fromISO(currentDate).toFormat(localizationStore.dateFormat) }}
            </span>
            <a class="cursor-pointer flex items-center text-lg text-white uppercase"
               v-on:click="nextWeek"
            >
                <span class="hidden md:inline">{{ __('Következő') }}</span>
                <c-icon class="h-6 ml-2 stroke-white w-6" icon="chevron-right" />
            </a>
        </div>
        <div class="bg-white border-b border-b-slate-100 grid grid-cols-5 font-semibold px-2 sticky text-center top-[calc(4rem+var(--banner-offset))] xl:grid-cols-10 z-30">
            <span class="flex items-center justify-center p-4"></span>
            <span class="border-l col-span-2 flex items-center justify-center p-4 xl:col-span-3">
                {{ __('Termék') }}
            </span>
            <span class="border-l hidden items-center justify-center p-4 xl:flex xl:flex-col">
                {{ __('Ár') }}<br />
                <small v-if="user.group">
                    ({{ __(':group csoport', { group : user.group.name }) }} - {{ __(':discount% kedvezmény', { discount: user.group.discount }) }})
                </small>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
            >
                {{ __('Hétfő') }}<br />
                <span class="hidden xl:block">{{ currentDays.monday.month }} {{ currentDays.monday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
            >
                {{ __('Kedd') }}
                <span class="hidden xl:block">{{ currentDays.tuesday.month }} {{ currentDays.tuesday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >
                {{ __('Szerda') }}
                <span class="hidden xl:block">{{ currentDays.wednesday.month }} {{ currentDays.wednesday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >
                {{ __('Csütörtök') }}
                <span class="hidden xl:block">{{ currentDays.thursday.month }} {{ currentDays.thursday.day }}</span>
            </span>
            <span class="border-l col-span-2 hidden p-4 xl:col-span-1 xl:block"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >
                {{ __('Péntek') }}
                <span class="hidden xl:block">{{ currentDays.friday.month }} {{ currentDays.friday.day }}</span>
            </span>
        </div>
        <div v-for="product in products">
            <div class="border-t grid grid-cols-5 px-2 xl:grid-cols-10"
                 v-if="showProduct(product, currentYear + '.' + currentWeek)"
            >
                <span class="flex items-center justify-center p-1">
                    <img class="max-w-32 w-full" v-bind:alt="product.name" v-bind:src="product.picture" />
                </span>
                <span class="border-l col-span-2 flex flex-col items-start justify-center p-4 xl:col-span-3">
                    <strong class="block text-slate-800 text-sm">{{ product.name }}</strong>
                    <span class="mt-1 text-slate-500 text-xs">{{ product.description }}</span>

                    <div class="flex flex-col xl:hidden" v-if="user.group_id !== 'default' && product.prices[`${user.group_id}`]">
                        <span class="mt-4">
                            {{ currencyStore.format(product.prices[`${user.group_id}`], 'huf') }}
                        </span>

                        <span class="text-xs" v-if="product.prices[`${user.group_id}`]">
                            ({{ currencyStore.format(product.prices[`${user.group_id}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                    <div class="flex flex-col xl:hidden" v-else>
                        <span class="mt-4">
                            {{ currencyStore.format(product.price_gross, 'huf') }}
                        </span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.price_gross / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l hidden items-center justify-center p-4 text-center xl:flex">
                    <div class="flex flex-col" v-if="user.group_id !== 'default' && product.prices[`${user.group_id}`]">
                        <span>
                            {{ currencyStore.format(product.prices[`${user.group_id}`], 'huf') }}
                        </span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.prices[`${user.group_id}`] / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                    <div class="flex flex-col" v-else>
                        <span>{{ currencyStore.format(product.price_gross, 'huf') }}</span>

                        <span class="text-xs">
                            ({{ currencyStore.format(product.price_gross / (1 + product.vat_pct / 100), 'huf') }} + {{ __('ÁFA') }})
                        </span>
                    </div>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
                >
                    <span v-if="
                        checkCutoff('monday')
                        && (
                            product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`].monday?.perPerson > 0
                            || isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'monday')
                        )
                        && (!order || order.payment_status !== 'SUCCESS')
                    ">
                        <span class="block border-2 border-slate-400 cursor-pointer flex items-center h-12 justify-center rounded-full text-3xl text-center text-slate-400 w-12"
                              v-if="(!product.quantity?.[`${currentYear}.${currentWeek}`]?.monday || product.quantity?.[`${currentYear}.${currentWeek}`]?.monday === 0) && focusedInput !== product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.monday' && canIncreaseQuantity(product, 'monday')"
                              v-on:click="ensureQuantityWeek(product, `${currentYear}.${currentWeek}`); product.quantity[`${currentYear}.${currentWeek}`].monday = 1; isOrderUpdated = true;"
                        >
                            +
                        </span>

                        <div class="flex items-center"
                             v-else-if="product.quantity?.[`${currentYear}.${currentWeek}`]?.monday > 0"
                        >
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="decreaseQuantity(product, currentYear + '.' + currentWeek, 'monday')"
                            >
                                –
                            </span>
                            <span class="block border-2 cursor-pointer flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                                  v-bind:class="isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'monday') ? 'border-amber-500 bg-amber-50 text-amber-800' : 'border-highlight'"
                            >
                                <input class="bg-transparent outline-none spinner-none text-center w-8" type="number"
                                       v-bind:name="product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.monday'"
                                       v-model="product.quantity[`${currentYear}.${currentWeek}`].monday"
                                       v-on:blur="focusedInput = ''"
                                       v-on:change="enforceQuantityLimit(product, 'monday')"
                                       v-on:focus="focusedInput = product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.monday'"
                                />
                            </span>
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="increaseQuantity(product, currentYear + '.' + currentWeek, 'monday')"
                            >
                                +
                            </span>
                        </div>
                    </span>
                    <span class="block border-2 border-slate-400 cursor-default flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12" v-else-if="product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`]?.monday?.perPerson > 0 && product.quantity[`${currentYear}.${currentWeek}`]?.monday > 0">
                        {{ product.quantity[`${currentYear}.${currentWeek}`].monday }}
                    </span>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
                >
                    <span v-if="
                        checkCutoff('tuesday')
                        && (
                            product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`].tuesday?.perPerson > 0
                            || isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'tuesday')
                        )
                        && (!order || order.payment_status !== 'SUCCESS')
                    ">
                        <span class="block border-2 border-slate-400 cursor-pointer flex items-center h-12 justify-center rounded-full text-3xl text-center text-slate-400 w-12"
                              v-if="(!product.quantity?.[`${currentYear}.${currentWeek}`]?.tuesday || product.quantity?.[`${currentYear}.${currentWeek}`]?.tuesday === 0) && focusedInput !== product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.tuesday' && canIncreaseQuantity(product, 'tuesday')"
                              v-on:click="ensureQuantityWeek(product, `${currentYear}.${currentWeek}`); product.quantity[`${currentYear}.${currentWeek}`].tuesday = 1; isOrderUpdated = true;"
                        >
                            +
                        </span>

                        <div class="flex items-center"
                             v-else-if="product.quantity?.[`${currentYear}.${currentWeek}`]?.tuesday > 0"
                        >
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="decreaseQuantity(product, currentYear + '.' + currentWeek, 'tuesday')"
                            >
                                –
                            </span>
                            <span class="block border-2 cursor-pointer flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                                  v-bind:class="isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'tuesday') ? 'border-amber-500 bg-amber-50 text-amber-800' : 'border-highlight'"
                            >
                                <input class="bg-transparent outline-none spinner-none text-center w-8" type="number"
                                       v-bind:name="product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.tuesday'"
                                       v-model="product.quantity[`${currentYear}.${currentWeek}`].tuesday"
                                       v-on:blur="focusedInput = ''"
                                       v-on:change="enforceQuantityLimit(product, 'tuesday')"
                                       v-on:focus="focusedInput = product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.tuesday'"
                                />
                            </span>
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="increaseQuantity(product, currentYear + '.' + currentWeek, 'tuesday')"
                            >
                                +
                            </span>
                        </div>
                    </span>
                    <span class="block border-2 border-slate-400 cursor-default flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12" v-else-if="product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`]?.tuesday?.perPerson > 0 && product.quantity[`${currentYear}.${currentWeek}`]?.tuesday > 0">
                        {{ product.quantity[`${currentYear}.${currentWeek}`].tuesday }}
                    </span>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
                >
                    <span v-if="
                        checkCutoff('wednesday')
                        && (
                            product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`].wednesday?.perPerson > 0
                            || isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'wednesday')
                        )
                        && (!order || order.payment_status !== 'SUCCESS')
                    ">
                        <span class="block border-2 border-slate-400 cursor-pointer flex items-center h-12 justify-center rounded-full text-3xl text-center text-slate-400 w-12"
                              v-if="(!product.quantity?.[`${currentYear}.${currentWeek}`]?.wednesday || product.quantity?.[`${currentYear}.${currentWeek}`]?.wednesday === 0) && focusedInput !== product.id + '.' + `${currentYear}.${currentWeek}` + '.quantity.wednesday' && canIncreaseQuantity(product, 'wednesday')"
                              v-on:click="ensureQuantityWeek(product, `${currentYear}.${currentWeek}`); product.quantity[`${currentYear}.${currentWeek}`].wednesday = 1; isOrderUpdated = true;"
                        >
                            +
                        </span>

                        <div class="flex items-center"
                             v-else-if="product.quantity?.[`${currentYear}.${currentWeek}`]?.wednesday > 0"
                        >
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="decreaseQuantity(product, currentYear + '.' + currentWeek, 'wednesday')"
                            >
                                –
                            </span>
                            <span class="block border-2 cursor-pointer flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                                  v-bind:class="isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'wednesday') ? 'border-amber-500 bg-amber-50 text-amber-800' : 'border-highlight'"
                            >
                                <input class="bg-transparent outline-none spinner-none text-center w-8" type="number"
                                       v-bind:name="product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.wednesday'"
                                       v-model="product.quantity[`${currentYear}.${currentWeek}`].wednesday"
                                       v-on:blur="focusedInput = ''"
                                       v-on:change="enforceQuantityLimit(product, 'wednesday')"
                                       v-on:focus="focusedInput = product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.wednesday'"
                                />
                            </span>
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="increaseQuantity(product, currentYear + '.' + currentWeek, 'wednesday')"
                            >
                                +
                            </span>
                        </div>
                    </span>
                    <span class="block border-2 border-slate-400 cursor-default flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12" v-else-if="product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`]?.wednesday?.perPerson > 0 && product.quantity[`${currentYear}.${currentWeek}`]?.wednesday > 0">
                        {{ product.quantity[`${currentYear}.${currentWeek}`].wednesday }}
                    </span>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
                >
                    <span v-if="
                        checkCutoff('thursday')
                        && (
                            product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`].thursday?.perPerson > 0
                            || isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'thursday')
                        )
                        && (!order || order.payment_status !== 'SUCCESS')
                    ">
                        <span class="block border-2 border-slate-400 cursor-pointer flex items-center h-12 justify-center rounded-full text-3xl text-center text-slate-400 w-12"
                              v-if="(!product.quantity?.[`${currentYear}.${currentWeek}`]?.thursday || product.quantity?.[`${currentYear}.${currentWeek}`]?.thursday === 0) && focusedInput !== product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.thursday' && canIncreaseQuantity(product, 'thursday')"
                              v-on:click="ensureQuantityWeek(product, `${currentYear}.${currentWeek}`); product.quantity[`${currentYear}.${currentWeek}`].thursday = 1; isOrderUpdated = true;"
                        >
                            +
                        </span>

                        <div class="flex items-center"
                             v-else-if="product.quantity?.[`${currentYear}.${currentWeek}`]?.thursday > 0"
                        >
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="decreaseQuantity(product, currentYear + '.' + currentWeek, 'thursday')"
                            >
                                –
                            </span>
                            <span class="block border-2 cursor-pointer flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                                  v-bind:class="isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'thursday') ? 'border-amber-500 bg-amber-50 text-amber-800' : 'border-highlight'"
                            >
                                <input class="bg-transparent outline-none spinner-none text-center w-8" type="number"
                                       v-bind:name="product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.thursday'"
                                       v-model="product.quantity[`${currentYear}.${currentWeek}`].thursday"
                                       v-on:blur="focusedInput = ''"
                                       v-on:change="enforceQuantityLimit(product, 'thursday')"
                                       v-on:focus="focusedInput = product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.thursday'"
                                />
                            </span>
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="increaseQuantity(product, currentYear + '.' + currentWeek, 'thursday')"
                            >
                                +
                            </span>
                        </div>
                    </span>
                    <span class="block border-2 border-slate-400 cursor-default flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12" v-else-if="product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`]?.thursday?.perPerson > 0 && product.quantity[`${currentYear}.${currentWeek}`]?.thursday > 0">
                        {{ product.quantity[`${currentYear}.${currentWeek}`].thursday }}
                    </span>
                </span>
                <span class="border-l col-span-2 flex-col hidden items-center justify-center p-4 xl:col-span-1 xl:flex"
                      v-bind:class="{ '!flex' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
                >
                    <span v-if="
                        checkCutoff('friday')
                        && (
                            product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`].friday?.perPerson > 0
                            || isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'friday')
                        )
                        && (!order || order.payment_status !== 'SUCCESS')
                    ">
                        <span class="block border-2 border-slate-400 cursor-pointer flex items-center h-12 justify-center rounded-full text-3xl text-center text-slate-400 w-12"
                              v-if="(!product.quantity?.[`${currentYear}.${currentWeek}`]?.friday || product.quantity?.[`${currentYear}.${currentWeek}`]?.friday === 0) && focusedInput !== product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.friday' && canIncreaseQuantity(product, 'friday')"
                              v-on:click="ensureQuantityWeek(product, `${currentYear}.${currentWeek}`); product.quantity[`${currentYear}.${currentWeek}`].friday = 1; isOrderUpdated = true;"
                        >
                            +
                        </span>

                        <div class="flex items-center"
                             v-else-if="product.quantity?.[`${currentYear}.${currentWeek}`]?.friday > 0"
                        >
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="decreaseQuantity(product, currentYear + '.' + currentWeek, 'friday')"
                            >
                                –
                            </span>
                            <span class="block border-2 cursor-pointer flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12"
                                  v-bind:class="isLegacyOrderedRow(product, `${currentYear}.${currentWeek}`, 'friday') ? 'border-amber-500 bg-amber-50 text-amber-800' : 'border-highlight'"
                            >
                                <input class="bg-transparent outline-none spinner-none text-center w-8" type="number"
                                       v-bind:name="product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.friday'"
                                       v-model="product.quantity[`${currentYear}.${currentWeek}`].friday"
                                       v-on:blur="focusedInput = ''"
                                       v-on:change="enforceQuantityLimit(product, 'friday')"
                                       v-on:focus="focusedInput = product.id + '.quantity.' + `${currentYear}.${currentWeek}` + '.friday'"
                                />
                            </span>
                            <span class="cursor-pointer text-3xl"
                                  v-on:click="increaseQuantity(product, currentYear + '.' + currentWeek, 'friday')"
                            >
                                +
                            </span>
                        </div>
                    </span>
                    <span class="block border-2 border-slate-400 cursor-default flex items-center h-12 justify-center mx-3 rounded-full text-2xl text-center w-12" v-else-if="product.availability[`${user.group_id}`][`${currentYear}.${currentWeek}`]?.friday?.perPerson > 0 && product.quantity[`${currentYear}.${currentWeek}`]?.friday > 0">
                        {{ product.quantity[`${currentYear}.${currentWeek}`].friday }}
                    </span>
                </span>
            </div>
        </div>
        <div class="font-bold py-4 text-center"
             v-if="!hasAvailableProducts(currentYear + '.' + currentWeek)"
        >
            {{ __('Nincsenek elérhető termékek erre a hétre.') }}
        </div>

        <div class="bg-highlight font-semibold grid grid-cols-5 items-center mt-4 px-2 text-xl text-center text-white uppercase xl:grid-cols-10">
            <span class="col-span-3 px-4 py-2 xl:col-span-5">{{ __('Összesen') }}</span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'monday' }"
            >
                {{ currencyStore.format(totalPrice.monday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.monday.net">
                    {{ currencyStore.format(totalPrice.monday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'tuesday' }"
            >
                {{ currencyStore.format(totalPrice.tuesday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.tuesday.net">
                    {{ currencyStore.format(totalPrice.tuesday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'wednesday' }"
            >
                {{ currencyStore.format(totalPrice.wednesday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.wednesday.net">
                    {{ currencyStore.format(totalPrice.wednesday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'thursday' }"
            >
                {{ currencyStore.format(totalPrice.thursday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.thursday.net">
                    {{ currencyStore.format(totalPrice.thursday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
            <span class="border-l border-l-white col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"
                  v-bind:class="{ '!block' : currentDate.weekdayLong.toLowerCase() === 'friday' }"
            >
                {{ currencyStore.format(totalPrice.friday.gross, 'huf') }}
                <span class="block text-xs" v-if="totalPrice.friday.net">
                    {{ currencyStore.format(totalPrice.friday.net, 'huf') }} + {{ __('ÁFA') }}
                </span>
            </span>
        </div>

        <div class="font-semibold grid grid-cols-5 items-center my-4 px-2 text-lg text-center xl:grid-cols-10">
            <span class="col-span-3 px-4 py-2 xl:col-span-5">{{ __('Kiszállítás') }}</span>
            <span class="border-l border-l-slate-200 col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"

            >
                <span v-if="totalPrice.monday.gross >= currencyStore.shipping_limits.zone && totalPrice.monday.gross < currencyStore.shipping_limits.free">
                    {{ currencyStore.format(user.shipping_cost ?? currencyStore.shipping_costs[user.shipping_zone ?? 'default'], 'huf') }}
                </span>
                <span v-else>
                    <span v-if="totalPrice.monday.gross < currencyStore.shipping_limits.zone">
                        {{ __('Személyes átvétel') }}
                    </span>
                    <span v-else>
                        {{ __('Ingyenes szállítás') }}
                    </span>
                </span>
            </span>
            <span class="border-l border-l-slate-200 col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"

            >
                <span v-if="totalPrice.tuesday.gross >= currencyStore.shipping_limits.zone && totalPrice.tuesday.gross < currencyStore.shipping_limits.free">
                    {{ currencyStore.format(user.shipping_cost ?? currencyStore.shipping_costs[user.shipping_zone ?? 'default'], 'huf') }}
                </span>
                <span v-else>
                    <span v-if="totalPrice.tuesday.gross < currencyStore.shipping_limits.zone">
                        {{ __('Személyes átvétel') }}
                    </span>
                    <span v-else>
                        {{ __('Ingyenes szállítás') }}
                    </span>
                </span>
            </span>
            <span class="border-l border-l-slate-200 col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"

            >
                <span v-if="totalPrice.wednesday.gross >= currencyStore.shipping_limits.zone && totalPrice.wednesday.gross < currencyStore.shipping_limits.free">
                    {{ currencyStore.format(user.shipping_cost ?? currencyStore.shipping_costs[user.shipping_zone ?? 'default'], 'huf') }}
                </span>
                <span v-else>
                    <span v-if="totalPrice.wednesday.gross < currencyStore.shipping_limits.zone">
                        {{ __('Személyes átvétel') }}
                    </span>
                    <span v-else>
                        {{ __('Ingyenes szállítás') }}
                    </span>
                </span>
            </span>
            <span class="border-l border-l-slate-200 col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"

            >
                <span v-if="totalPrice.thursday.gross >= currencyStore.shipping_limits.zone && totalPrice.thursday.gross < currencyStore.shipping_limits.free">
                    {{ currencyStore.format(user.shipping_cost ?? currencyStore.shipping_costs[user.shipping_zone ?? 'default'], 'huf') }}
                </span>
                <span v-else>
                    <span v-if="totalPrice.thursday.gross < currencyStore.shipping_limits.zone">
                        {{ __('Személyes átvétel') }}
                    </span>
                    <span v-else>
                        {{ __('Ingyenes szállítás') }}
                    </span>
                </span>
            </span>
            <span class="border-l border-l-slate-200 col-span-2 hidden px-4 py-2 xl:block xl:col-span-1"

            >
                <span v-if="totalPrice.friday.gross >= currencyStore.shipping_limits.zone && totalPrice.friday.gross < currencyStore.shipping_limits.free">
                    {{ currencyStore.format(user.shipping_cost ?? currencyStore.shipping_costs[user.shipping_zone ?? 'default'], 'huf') }}
                </span>
                <span v-else>
                    <span v-if="totalPrice.friday.gross < currencyStore.shipping_limits.zone">
                        {{ __('Személyes átvétel') }}
                    </span>
                    <span v-else>
                        {{ __('Ingyenes szállítás') }}
                    </span>
                </span>
            </span>
        </div>
    </div>

    <div class="mx-2 pb-40">
        <div class="bg-white border border-slate-200 flex items-center justify-center lg:w-1/2 mx-auto mt-8 p-2 rounded text-sm" id="tos">
            <c-control-toggle class="h-[30px] mr-4" name="accepted" v-model="accepted" />
            <span class="cursor-pointer" v-html="__('acceptPaymentTerms')" v-on:click="accepted = !accepted" />
        </div>

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight md:w-96 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-full"
                  v-bind:disabled="(isOriginalCartEmpty && isCartEmpty(currentYear + '.' + currentWeek)) || !accepted || saving"
                  v-if="products && !user.group?.is_webshop_enabled"
                  v-on:click="submit"
        >
            {{ __('Rendelés mentése') }}
        </c-button>

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight md:w-96 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-full"
                  v-bind:disabled="isCartEmpty(currentYear + '.' + currentWeek) || order?.payment_status === 'SUCCESS' || !accepted || saving"
                  v-if="products && user.group?.is_webshop_enabled"
                  v-on:click="submitAndPay"
        >
            <c-icon class="h-6 inline mr-4 -mt-px stroke-white w-6" icon="credit-card" />
            {{ __('Online fizetés') }}
        </c-button>

        <c-button class="bg-transparent border-2 border-slate-800 font-semibold hover:border-highlight hover:text-highlight md:w-96 mx-auto my-4 normal-case px-4 py-2 rounded-none table text-center !text-lg text-slate-800 transition-colors w-full" router
                  v-bind:to="{ name: 'order.previous' }"
                  v-if="sessionStore.user.role !== 'user'"
        >
            {{ __('Korábbi rendelés újra leadása') }}
        </c-button>

        <a href="https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" target="_blank"
           v-if="user.group?.is_webshop_enabled"
        >
            <img class="mx-auto" src="/img/simplepay.png" title="SimplePay - Online bankkártyás fizetés" alt="SimplePay vásárlói tájékoztató" />
        </a>

        <div class="bottom-20 fixed flex flex-col items-start left-2 max-w-[20rem] pointer-events-none right-auto z-20">
            <div class="bg-warning flex items-center mb-2 pointer-events-auto px-3 py-2 rounded-lg shadow-md text-amber-700 text-left text-sm transition-all"
                v-if="showTosAlert && !accepted"
            >
                <c-icon class="h-5 mr-2 shrink-0 stroke-amber-700 w-5" icon="alert-triangle" />
                {{ __('A rendelés akkor menthető ha elfogadod az adatkezelési tájékoztatót.') }}
                <button class="ml-2 shrink-0" type="button" v-on:click="showTosAlert = false">
                    <c-icon class="h-4 stroke-amber-700 w-4" icon="x" />
                </button>
            </div>

            <div class="bg-warning flex items-center pointer-events-auto px-3 py-2 rounded-lg shadow-md text-amber-700 text-left text-sm transition-all"
                v-if="isOrderUpdated && !isOrderUpdatedAlertDismissed"
            >
                <c-icon class="h-5 mr-2 shrink-0 stroke-amber-700 w-5" icon="alert-triangle" />
                {{ __('Ne felejtsd el rendelésedet megerősíteni!') }}
                <button class="ml-2 shrink-0" type="button" v-on:click="isOrderUpdatedAlertDismissed = true">
                    <c-icon class="h-4 stroke-amber-700 w-4" icon="x" />
                </button>
            </div>
        </div>
    </div>

    <div class="bottom-2 fixed flex items-center right-2 z-20">
        <a class="bg-success border border-white cursor-pointer flex items-center justify-center font-bold h-12 mr-2 px-4 rounded-full shadow-lg text-sm text-white"
           v-bind:class="{ '!bg-emerald-200 !cursor-not-allowed !pointer-events-none' : (isOriginalCartEmpty && isCartEmpty(currentYear + '.' + currentWeek)) || saving }"
           v-if="products && !user.group?.is_webshop_enabled"
           v-on:click="accepted ? submit() : scrollToTOS()"
        >
            {{ __('Mentés') }}
        </a>
        <a class="bg-success border border-white cursor-pointer flex items-center justify-center mr-2 size-12 rounded-full shadow-lg"
           v-bind:class="{ '!bg-emerald-200 !cursor-not-allowed !pointer-events-none' : isCartEmpty(currentYear + '.' + currentWeek) || order?.payment_status === 'SUCCESS' || !accepted || saving }"
           v-if="products && user.group?.is_webshop_enabled"
           v-on:click="accepted ? submitAndPay() : scrollToTOS()"
        >
            <c-icon class="h-8 stroke-white w-8" icon="credit-card" />
        </a>
        <a class="bg-slate-800 border border-white cursor-pointer flex items-center justify-center size-12 rounded-full shadow-lg"
           v-on:click="scrollToTop"
        >
            <c-icon class="h-8 stroke-white w-8" icon="chevron-up" />
        </a>
    </div>
</template>

<script setup lang="ts">
    import { computed, inject, onMounted, ref, watch } from 'vue';
    import { useRoute } from 'vue-router';
    import {
        CButton,
        CControlToggle,
        CIcon,
    } from '@teamfurther/cinderblock';
    import { DateTime } from 'luxon';
    import OrderRepository from '../repositories/OrderRepository';
    import ProductRepository from '../repositories/ProductRepository';
    import { useCurrencyStore } from '../stores/currency';
    import { useLocalizationStore } from '../stores/localization';
    import { useRequestStore } from '../stores/request';
    import { useSessionStore } from '../stores/session';

    const __ = inject('__');
    const accepted = ref(false);
    const breakpoint = 1280;
    const currencyStore = useCurrencyStore();
    const currentBreakpoint = ref(window.innerWidth);
    const currentDate = ref(DateTime.now().setLocale('en'));
    const localizationStore = useLocalizationStore();
    const currentDays = computed(() => {
        const firstDay = currentDate.value.startOf('week');

        return {
            monday: {
                date: firstDay,
                day: firstDay.day,
                month: firstDay.setLocale(localizationStore.locale).toFormat('MMM')
            },
            tuesday: {
                date: firstDay.plus({ days: 1 }),
                day: firstDay.plus({ days: 1 }).day,
                month: firstDay.plus({ days: 1 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            wednesday: {
                date: firstDay.plus({ days: 2 }),
                day: firstDay.plus({ days: 2 }).day,
                month: firstDay.plus({ days: 2 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            thursday: {
                date: firstDay.plus({ days: 3 }),
                day: firstDay.plus({ days: 3 }).day,
                month: firstDay.plus({ days: 3 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
            friday: {
                date: firstDay.plus({ days: 4 }),
                day: firstDay.plus({ days: 4 }).day,
                month: firstDay.plus({ days: 4 }).setLocale(localizationStore.locale).toFormat('MMM')
            },
        }
    });
    const currentDay = computed(() => {
        return currentDate.value.ordinal;
    });
    const currentWeek = computed(() => {
        return currentDate.value.weekNumber;
    });
    const currentYear = computed(() => {
        return currentDate.value.year;
    });
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
    const focusedInput = ref<string>('');
    const isAdmin = computed(() => {
        return (user.value.role === 'admin' || originalUser.value?.role === 'admin');
    });
    const isOriginalCartEmpty = ref(true);
    const isOrderUpdated = ref(false);
    const isOrderUpdatedAlertDismissed = ref(false);
    const openInstructions = ref<boolean>(window.localStorage.getItem('showInstructions') !== 'false');
    const order = ref();
    const orderRepository = new OrderRepository();
    const originalUser = ref(null);
    const productRepository = new ProductRepository();
    const products = ref();
    const requestStore = useRequestStore();
    const route = useRoute();
    const saving = ref(false);
    const showTosAlert = ref(false);
    const totalPrice = computed(() => {
        let total = {
            monday: { net: 0, gross: 0 },
            tuesday: { net: 0, gross: 0 },
            wednesday: { net: 0, gross: 0 },
            thursday: { net: 0, gross: 0 },
            friday: { net: 0, gross: 0 },
        };

        products.value.forEach((product) => {
            const price = product.prices[user.value.group_id] ?? product.price_gross;

            const mondayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['monday'] ?? 0;
            total.monday.gross += mondayQty * price;
            total.monday.net += mondayQty * price / (1 + product.vat_pct / 100);

            const tuesdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['tuesday'] ?? 0;
            total.tuesday.gross += tuesdayQty * price;
            total.tuesday.net += tuesdayQty * price / (1 + product.vat_pct / 100);

            const wednesdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['wednesday'] ?? 0;
            total.wednesday.gross += wednesdayQty * price;
            total.wednesday.net += wednesdayQty * price / (1 + product.vat_pct / 100);

            const thursdayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['thursday'] ?? 0;
            total.thursday.gross += thursdayQty * price;
            total.thursday.net += thursdayQty * price / (1 + product.vat_pct / 100);

            const fridayQty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.['friday'] ?? 0;
            total.friday.gross += fridayQty * price;
            total.friday.net += fridayQty * price / (1 + product.vat_pct / 100);
        });

        return total;
    });
    const sessionStore = useSessionStore();
    const user = ref(sessionStore.user);

    watch(isOrderUpdated, (value) => {
        if (value) {
            isOrderUpdatedAlertDismissed.value = false;
        }
    });

    function addMissingAvailabilityData() {
        products.value.forEach((product) => {
            if (!product.quantity) {
                product.quantity = {};
            }

            if (!product.quantity[`${currentYear.value}.${currentWeek.value}`]) {
                product.quantity[`${currentYear.value}.${currentWeek.value}`] = {
                    monday: 0,
                    tuesday: 0,
                    wednesday: 0,
                    thursday: 0,
                    friday: 0,
                };
            }

            if (!product.availability[`${user.value.group_id}`]) {
                product.availability[`${user.value.group_id}`] = {};
            }

            if (!product.availability[`${user.value.group_id}`][`${currentYear.value}.${currentWeek.value}`]) {
                product.availability[`${user.value.group_id}`][`${currentYear.value}.${currentWeek.value}`] = {
                    monday: { perPerson: null, total: null },
                    tuesday: { perPerson: null, total: null },
                    wednesday: { perPerson: null, total: null },
                    thursday: { perPerson: null, total: null },
                    friday: { perPerson: null, total: null },
                };
            }
        });
    }

    function checkCutoff(day) {
        if (isAdmin.value) {
            return true;
        }

        const checkDate = currentDate.value.set({
            weekday: days.indexOf(day) + 1,
        });

        const cutoffDate = checkDate.minus({ days: 2 }).set({ hour: 9, minute: 0, second: 0, millisecond: 0 });

        return DateTime.now().setLocale('en') <= cutoffDate;
    }

    function decreaseQuantity(product, week, day) {
        product.quantity[week][day] -= 1;

        isOrderUpdated.value = true;
    }

    function ensureQuantityWeek(product, week) {
        if (!product.quantity) {
            product.quantity = {};
        }

        if (!product.quantity[week]) {
            product.quantity[week] = {
                monday: 0,
                tuesday: 0,
                wednesday: 0,
                thursday: 0,
                friday: 0,
            };
        }
    }

    async function getOrder() {
        const orders = await orderRepository.index({
            filters: {
                user_id: user.value.id,
                week: currentYear.value + '.' + currentWeek.value,
            },
            include: ['items']
        });

        order.value = orders[0];

        if (order.value && order.value.items.length > 0) {
            order.value.items.forEach((item) => {
                products.value.forEach((product) => {
                    if (product.id === item.product_id) {
                        if (!product.quantity[order.value.year + '.' + order.value.week]) {
                            product.quantity[order.value.year + '.' + order.value.week] = {};
                        }

                        product.quantity[order.value.year + '.' + order.value.week][item.day] = item.quantity;
                    }
                });
            });
        }
    }

    async function getProducts() {
        products.value = await productRepository.index({
            filters: {
                active: true,
            },
        });

        addMissingAvailabilityData();
    }

    function hasAvailableProducts(week) {
        let found = false;

        products.value.forEach(product => {
            if (showProduct(product, week)) {
                found = true;
            }
        });

        return found;
    }

    function canIncreaseQuantity(product, day) {
        const avail = product.availability[`${user.value.group_id}`][`${currentYear.value}.${currentWeek.value}`][day];
        const qty = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.[day] ?? 0;

        return avail.perPerson > qty
            && avail.total > avail.totalOrdered + qty;
    }

    function enforceQuantityLimit(product: any, day: any) {
        const avail = product.availability?.[`${(user.value as any).group_id}`]?.[`${currentYear.value}.${currentWeek.value}`]?.[day];
        if (!avail?.perPerson) {
            return;
        }
        const max = Math.min(avail.perPerson, avail.total - avail.totalOrdered);
        const current = product.quantity?.[`${currentYear.value}.${currentWeek.value}`]?.[day] ?? 0;
        if (current > max) {
            alert(__('A megadott mennyiség nagyobb mint a maximum rendelhető.'));
            product.quantity[`${currentYear.value}.${currentWeek.value}`][day] = Math.max(0, max);
            isOrderUpdated.value = true;
        }
    }

    function increaseQuantity(product, week, day) {
        if (
            product.availability[`${user.value.group_id}`][`${currentYear.value}.${currentWeek.value}`][day].perPerson > product.quantity[week][day]
            && product.availability[`${user.value.group_id}`][`${currentYear.value}.${currentWeek.value}`][day].total > product.availability[`${user.value.group_id}`][`${currentYear.value}.${currentWeek.value}`][day].totalOrdered + product.quantity[week][day]
        ) {
            product.quantity[week][day] += 1;

            isOrderUpdated.value = true;
        } else {
            alert(__('A megadott mennyiség nagyobb mint a maximum rendelhető.'));
            const avail = product.availability[`${user.value.group_id}`][`${currentYear.value}.${currentWeek.value}`][day];
            const max = Math.min(avail.perPerson, avail.total - avail.totalOrdered);
            product.quantity[week][day] = Math.max(0, max);
            isOrderUpdated.value = true;
        }
    }

    function isCartEmpty(week) {
        if (!hasAvailableProducts(week)) {
            return true;
        }

        let found = false;

        products.value.forEach((product) => {
            if (
                product.quantity[week]?.monday > 0
                || product.quantity[week]?.tuesday > 0
                || product.quantity[week]?.wednesday > 0
                || product.quantity[week]?.thursday > 0
                || product.quantity[week]?.friday > 0
            ) {
                found = true;
            }
        });

        return !found;
    }

    async function nextWeek() {
        currentDate.value = breakpoint < currentBreakpoint.value
            ? currentDate.value.plus({ weeks: 1 })
            : currentDate.value.plus({ days: 1 });

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        }

        await getOrder();
        addMissingAvailabilityData();
        isOriginalCartEmpty.value = isCartEmpty(currentYear.value + '.' + currentWeek.value);
    }

    async function prevWeek() {
        currentDate.value = breakpoint < currentBreakpoint.value
            ? currentDate.value.minus({ weeks: 1 })
            : currentDate.value.minus({ days: 1 });

        if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.minus({ day: 2 });
        }

        await getOrder();
        addMissingAvailabilityData();
        isOriginalCartEmpty.value = isCartEmpty(currentYear.value + '.' + currentWeek.value);
    }

    function scrollToTOS() {
        showTosAlert.value = true;

        window.scrollTo({
            behavior: 'smooth',
            top: document.getElementById('tos').offsetTop,
        });
    }

    function scrollToTop() {
        window.scrollTo({
            behavior: 'smooth',
            top: 0,
        });
    }

    function hasAnyQuantityForWeek(product: any, week: any) {
        const q = product.quantity?.[week];
        if (!q) return false;
        return days.some((day) => (q[day] ?? 0) > 0);
    }

    function isLegacyOrderedRow(product: any, week: any, day: any) {
        const perPerson = product.availability?.[`${(user.value as any).group_id}`]?.[week]?.[day]?.perPerson;
        const qty = product.quantity?.[week]?.[day] ?? 0;
        return isAdmin.value && (!perPerson || perPerson <= 0) && qty > 0;
    }

    function showProduct(product: any, week: any) {
        const hasAvailability = product.availability[`${(user.value as any).group_id}`][`${week}`]?.monday?.perPerson > 0
            || product.availability[`${(user.value as any).group_id}`][`${week}`]?.tuesday?.perPerson > 0
            || product.availability[`${(user.value as any).group_id}`][`${week}`]?.wednesday?.perPerson > 0
            || product.availability[`${(user.value as any).group_id}`][`${week}`]?.thursday?.perPerson > 0
            || product.availability[`${(user.value as any).group_id}`][`${week}`]?.friday?.perPerson > 0;

        return hasAvailability || (isAdmin.value && hasAnyQuantityForWeek(product, week));
    }

    async function submit() {
        if (!accepted.value) {
            return;
        }

        isOrderUpdated.value = false;

        saving.value = true;

        await orderRepository.storeBatch(products.value);

        await getOrder();

        saving.value = false;
    }

    async function submitAndPay() {
        if (!accepted.value) {
            return;
        }

        saving.value = true;

        await orderRepository.storeBatch(products.value);

        await getOrder();

        await requestStore.put('payments/pay/' + order.value.id, {}).then((response: any) => {
            window.location.href = response.data;
        });

        isOrderUpdated.value = false;
        saving.value = false;
    }

    onMounted(async () => {
        window.localStorage.setItem('showInstructions', 'false');

        if (window.localStorage.getItem('originalUser')) {
            originalUser.value = JSON.parse(window.localStorage.getItem('originalUser'));
        }

        await getProducts();

        window.addEventListener('resize', () => {
            currentBreakpoint.value = window.innerWidth;
        });

        await getOrder();

        if (route.query.week) {
            const week = route.query.week.split('.');

            currentDate.value = DateTime.fromObject({ weekYear: week[0], weekNumber: week[1] });
        }

        if (currentDate.value.weekday === 6) {
            currentDate.value = currentDate.value.plus({ day: 2 });
        } else if (currentDate.value.weekday === 7) {
            currentDate.value = currentDate.value.plus({ day: 1 });
        }

        await getOrder();

        isOriginalCartEmpty.value = isCartEmpty(currentYear.value + '.' + currentWeek.value);
    });
</script>
